import { useState, useCallback } from 'react'
import { apiClient } from '../api/client'

type UseLineNotifyResult = {
  sending: boolean
  error: string | null
  sendMessage: (to: string, text: string) => Promise<boolean>
  clearError: () => void
}

/**
 * LINE 通知送信を管理するフック
 *
 * useSettings と同じ saving/error パターン。送信成否を boolean で返す。
 */
export function useLineNotify(): UseLineNotifyResult {
  const [sending, setSending] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const sendMessage = useCallback(async (to: string, text: string): Promise<boolean> => {
    setSending(true)
    setError(null)

    try {
      await apiClient.sendLineMessage({ to, text })
      return true
    } catch (err) {
      console.error('Failed to send LINE message:', err)
      setError(err instanceof Error ? err.message : 'LINE への送信に失敗しました')
      return false
    } finally {
      setSending(false)
    }
  }, [])

  const clearError = useCallback(() => setError(null), [])

  return { sending, error, sendMessage, clearError }
}
